import styled, { css } from "styled-components";

export const ProgressTabsWrapper = styled.div`
  width: 100%;
  max-width: 700px;
`;

export const ProgressTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
`;

export const ProgressTabWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  max-height: 100%;
  transition: 0.2s;
`;

export const ProgressTabContainer = styled.div<{
  $simple?: boolean;
  $unstyled?: boolean;
}>`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  padding: 24px;
  gap: 24px;
  border: 1px solid ${({ theme }) => theme.colors.default[100]};
  background: ${({ theme }) => theme.colors.base};
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  ${({ $simple }) =>
    $simple &&
    css`
      padding: 0;
      overflow: clip;
    `}
  ${({ $unstyled }) =>
    $unstyled &&
    css`
      border: none;
      background: none;
      box-shadow: none;
      padding: 0;
    `}
`;

export const TabNavigationWrapper = styled.div``;

export const TabNavigationContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
`;
